import React, {SVGProps} from 'react';
import {ReactComponent} from '../../assets/svg/pull-up-chevron.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;